// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var treeViewColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        text: tx.primary,
        focus: {
            border: bd.actionBold
        },
        hover: {
            background: bg.state.hover0
        },
        selected: {
            background: bg.state.selectedTransparent
        },
        hoverSelected: {
            background: bg.state.selectedTransparent2
        }
    };
};

//# sourceMappingURL=treeViewColors.js.map